import React from "react";

interface ModalContentProps {
  children: React.ReactNode;
}

const ModalContent: React.FC<ModalContentProps> = ({ children }) => (
  <div className="p-4 text-gray-800">{children}</div>
);

export default ModalContent;
